import { useEffect, useState } from 'react';
import Select from 'react-select';

const getCustomSelectStyles = (theme) => ({
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isDisabled
    ? (theme === 'light' ? '#edf2f9 !important' : '#232e3c')
    : (theme === 'dark' ? '#232e3c' : 'white'),
    // backgroundColor: theme === 'dark' ? '#2d2f38' : 'white',
    color: theme === 'dark' ? '#f8f9fa' : '#212529',
    border: '1px solid #ced4da',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#80bdff'
    }
  }),   
    option: (provided, { isFocused, isSelected }) => ({
      ...provided,
      backgroundColor: isSelected
        ? theme === 'dark'
          ? '#2d2f38'
          :  '#e9ecef !important'
        : isFocused
          ? theme === 'dark'
            ? '#3a3b3f'
            : '#f8f9fa !important'
          : theme === 'dark'
            ? '#1e1f23'
            : "white !important",
      color: theme === 'dark' ? '#f8f9fa' : "#212529 !important",
      cursor: 'pointer',
    }),  
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? '#6c757d' : (theme === 'dark' ? '#f8f9fa' : '#212529'),
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: '#6c757d',
      opacity: 1,
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      display: state.isDisabled ? 'none' : 'flex',
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled ? 'transparent' : provided.backgroundColor,
    }),
    menuPortal: provided => ({
      ...provided,
      zIndex: 9999
    }),
    menu: provided => ({
      ...provided,
      zIndex: 9999
    })
  });
  

const ThemedSelect = (props) => {
  const [theme, setTheme] = useState(document.documentElement.getAttribute('data-bs-theme') || 'light');

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const currentTheme = document.documentElement.getAttribute('data-bs-theme') || 'light';
      setTheme(currentTheme);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme'],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Select
      {...props}
      classNamePrefix="react-select"
      className={`${props.errors?.pres_drug ? 'is-invalid' : ''}`}
      styles={getCustomSelectStyles(theme)}
    />
  );
};

export default ThemedSelect;
